export default "__VITE_ASSET__D5e$btvZ__"